import moment from "moment";

export default function getDiffMinutes (date:Date, date2:Date) {
    const diff = (date2.getTime() - date.getTime() ) / (1000 * 60)
    return Math.round(diff)
  }


export const validarData = (data:string) => {    
    return moment(data, 'DD/MM/YYYY', true).isValid();            
};
  
export const toISOFormat = (dateTimeString: string) => {
  // Primeiro, dividimos a data completa em duas partes:
  const [DD, MM, YYYY] = dateTimeString.split('/');
  // Retornamos a data formatada em um padrão compatível com ISO:
  return `${YYYY}-${MM}-${DD}`;
}